import { FC } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from 'antd';
import UserAddOutlined from '@ant-design/icons/UserAddOutlined';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthCard from '@/features/signin/AuthCard';
import styles from '@/features/signin/signin.module.css';

/** Auth0 sign-up (screen_hint: signup), in the sign-in page frame. */
const SignUpPage: FC = () => {
  const { t } = useTranslation();
  const { loginWithRedirect, isLoading } = useAuth0();
  const navigate = useNavigate();

  const handleSignUp = async () => {
    try {
      await loginWithRedirect({
        authorizationParams: { screen_hint: 'signup' },
        appState: { returnTo: '/' },
      });
    } catch {
      // The Auth0 SDK reports its own failures on return.
    }
  };

  return (
    <AuthCard
      title={t('v2.signIn.signUpTitle')}
      lead={t('v2.signIn.signUpWelcome')}
    >
      <div className={styles.actions}>
        <Button
          type="primary"
          size="large"
          icon={<UserAddOutlined aria-hidden />}
          onClick={handleSignUp}
          loading={isLoading}
          block
          className={styles.primary}
        >
          {t('v2.signIn.signUpAuth0')}
        </Button>
      </div>
      <p className={styles.alternate}>
        {t('v2.signIn.haveAccount')}{' '}
        <button
          type="button"
          className={styles.link}
          onClick={() => navigate('/signin')}
        >
          {t('v2.signIn.signIn')}
        </button>
      </p>
    </AuthCard>
  );
};

export default SignUpPage;
